import { Part } from "./Part";
import { Empty3d } from "../arrangement3d/Empty3d";
import { v3 } from "oc-threejs/short3";
import * as Maths3 from "oc-threejs/Maths3";

/**
 * ein temporärer, rein interner Platzhalter
 */
export class Platzhalter extends Part {
  static CLASS_NAME = "Platzhalter";

  isPlatzhalter = true;

  constructor(parent) {
    super(parent);
  }

  clone() {
    return new Platzhalter(this.parent).copy(this);
  }

  createJaco3d() {
    return new Empty3d(this);
  }

  getBox() {
    return Maths3.boxFromGridMinAndSize(v3(0, 0, 0.5), v3(this.breite, 1, 0.1));
  }
}
